<template>
    <div class="action-open-chat-normal">
        <div class="title f-bold" v-html="$translate('ACTION_OPEN_CHAT_TITLE')" />
        <div class="body">
            <div v-html="body" />
        </div>
        <div v-if="chatUser && $store.getters.isMobile" class="bottom flex-row items-center">
            <div @click="onClickProfile" class="flex-row items-center flex-fill cursor-pointer">
                <div class="img-cover flex-wrap" v-img-cover="chatUser.photo_url" />
                <div>프로필 보기</div>
                <i class="zmdi zmdi-chevron-right" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ActionOpenChatNormal',
    props: ['message'],
    computed: {
        chat() {
            return this.$store.getters.chat
        },
        chatUser() {
            if (!this.chat) return

            return (this.chat || {}).user
        },
        body() {
            const body = this.$translate('ACTION_OPEN_CHAT_BODY')

            return body.replace(/%s/, this.$nameOrNick(this.chatUser))
        },
    },
    methods: {
        onClickProfile() {
            this.$router.push({ name: 'UserDetailPage', params: { userId: this.chatUser.id } })
        },
    },
}
</script>
